import { useMemo } from "react";
import { useContractRead } from "wagmi";
import { BigNumberish } from "ethers";
import useNftContract from "hooks/useNftContract";

const useMinimumDonation = (): BigNumberish | undefined => {
  const nftContract = useNftContract();

  const [{ data: minimumDonationData }] = useContractRead(
    {
      addressOrName: nftContract!.address,
      contractInterface: nftContract!.interface,
    },
    "minimumDonation"
  );

  return useMemo(
    () =>
      minimumDonationData ? (minimumDonationData as BigNumberish) : undefined,
    [minimumDonationData]
  );
};

export default useMinimumDonation;
